var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.48131 12.3987C3.30234 13.1007 0.211137 14.5342 2.09388 16.3279C3.01359 17.2041 4.03791 17.8307 5.32572 17.8307H12.6743C13.9621 17.8307 14.9864 17.2041 15.9061 16.3279C17.7889 14.5342 14.6977 13.1007 13.5187 12.3987C10.754 10.7525 7.24599 10.7525 4.48131 12.3987Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1381",
    d: "M12.75 4.91406C12.75 6.98513 11.0711 8.66406 9 8.66406C6.92893 8.66406 5.25 6.98513 5.25 4.91406C5.25 2.84299 6.92893 1.16406 9 1.16406C11.0711 1.16406 12.75 2.84299 12.75 4.91406Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.cf6f142eff6eb5cdbd9b05d407fb5524.svg";
export { ForwardRef as ReactComponent };